<mat-toolbar>
    <span id="forfalte-oppgaver-dokument-valg-dialog-tittel">{{ 'Velg dokumentinnhold' | translate }}</span>
    <span class="mellomrom"></span>
    <button mat-icon-button (click)="avbryt()">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>

<mat-dialog-content>
    <p>{{ 'Hva ønsker du å inkludere i oppgavedokumentet?' | translate }}</p>

    @for (del of deler(); track del.enumVerdi) {
        <mat-slide-toggle [formControl]="del.kontroll">
            {{ del.navn }}
        </mat-slide-toggle>
    }

    @if (ingenDelerValgt) {
        <inline-melding type="feil" class="feilmelding" data-testid="ingen-deler-valgt">
            {{ 'Minst ett alternativ må være valgt' | translate }}
        </inline-melding>
    }

    <inline-melding type="info" class="info-melding">
        {{ 'Dine valg vil lagres for alle eksisterende og fremtidige oppgave-dokument i denne gruppen. Du kan når som helst endre dette senere.' | translate }}
    </inline-melding>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-button (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" class="e2e-lagre" (click)="lagre()" [disabled]="lagrer() || ingenDelerValgt">{{ 'Lagre' | translate }}</button>
</mat-dialog-actions>
